import { mapActions } from 'vuex'

/**
 * This provides a util - refreshParentGoals. refreshParentGoals refreshes all the goals data in the parent hierarchy of passed goalId.
 */
export default {
  methods: {
    ...mapActions(['getGoal']),
    refreshParentGoals(goalId) {
      const goal = this.$store.getters.goalById(goalId)
      goal.parentGoalIds?.forEach(parentGoalId => {
        const parentGoal = this.$store.getters.goalById(parentGoalId)
        parentGoal &&
          this.getGoal({
            goalId: parentGoal.id,
            orgId: parentGoal.organizationId,
            options: {
              expand: 'parent_goal_ids'
            }
          })
        parentGoal?.parentGoalIds?.forEach(parentGoalId => {
          const goal = this.$store.getters.goalById(parentGoalId)
          goal &&
            this.getGoal({
              goalId: goal.id,
              orgId: goal.organizationId,
              options: {
                expand: 'parent_goal_ids'
              }
            })
          this.refreshParentGoals(parentGoalId)
        })
      })
    }
  }
}
